import type { ReactNode } from "react";

import Layout from "@/components/layout";
import useInitContextData from "@/context";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

interface PageShellProps {
  children: ReactNode;
  locationSearch: string;
}

function AppShell({ children }: { children: ReactNode }) {
  useInitContextData();
  useSmoothScroll();
  return <>{children}</>;
}

export default function PageShell({
  children,
  locationSearch,
}: PageShellProps) {
  return (
    <AppShell>
      <Layout locationSearch={locationSearch}>{children}</Layout>
    </AppShell>
  );
}
